// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1WWKQ","header":"PatientQuestionnaire_header__F2Sc6","info":"PatientQuestionnaire_info__2Y9mL"};